import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../../../front-end-global-components/components/Header/Header";
import {
  acceptPatientsRequest,
  denyPatientsRequest,
  disableAutoApprove,
  enableAutoApprove,
  revokePermission
} from "../../../redux/patients/actions";
import { isValidArray } from "../../../utils/validators";
import "../Abdm.css";
import ConsentRequest from "./ConsentRequest";
import { getheaderTitle } from "./constants";
import { SubscriptionRequest } from "./SubscriptionRequest";

const ViewRequest = (props) => {
  const { abdmRequestId, abdmRequestType } = useParams();
  const [isValidRequest, setIsValidRequest] = useState();
  const [moreProvider, setMoreProvider] = useState(false);
  const [moreHealthLockers, setMoreHealthLockers] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // check request id is valid or not
  useEffect(() => {
    const { currentProfile, requests } = props.patients;

    if (!abdmRequestId || typeof currentProfile !== "string") {
      return setIsValidRequest(false);
    }

    const requestList = requests?.[currentProfile]?.[`${abdmRequestType}s`];
    if (!isValidArray(requestList)) {
      return setIsValidRequest(false);
    }

    const abdmRequest = requestList.find((r) => r.requestId === abdmRequestId);
    if (abdmRequest) {
      setIsValidRequest(true);
    } else {
      setIsValidRequest(false);
    }
  }, [abdmRequestId, abdmRequestType, props.patients]);

  return (
    <>
      <Header
        title={
          moreProvider
            ? "All current providers"
            : getheaderTitle(abdmRequestType)
        }
        backButtonOnClick={() => {
          if (moreProvider) {
            setMoreProvider(false);
          } else if (location.pathname.includes("providersModal")) {
            navigate(-1);
          } else {
            navigate("/settings");
          }
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => navigate("/incidents")}
      />

      <section className="max-width-588px remaining-body-height margin-horizontal-auto display-flex flex-direction-column flex-justify-content-space-between">
        {isValidRequest && abdmRequestType === "consent" && (
          <ConsentRequest
            moreProviderOnclick={setMoreProvider}
            moreProvider={moreProvider}
            moreHealthLockersOnClick={setMoreHealthLockers}
            moreHealthLockers={moreHealthLockers}
            patients={props.patients}
            goBack={props.goBack}
            abdmRequestId={abdmRequestId}
            abdmRequestType={abdmRequestType}
            acceptRequest={(requestData, autoApprove) => {
              acceptPatientsRequest({
                requestData,
                autoApprove,
                requestId: abdmRequestId,
                requestType: abdmRequestType,
                navigate
              });
            }}
            revokePermission={(pin) => {
              revokePermission({
                requestType: abdmRequestType,
                requestId: abdmRequestId,
                pin,
                navigate
              });
            }}
            denyRequest={(denyReason) => {
              denyPatientsRequest({
                requestType: abdmRequestType,
                requestId: abdmRequestId,
                denyReason,
                navigate
              });
            }}
            disableAutoApprove={(pin, autoApprovalId, requestId) => {
              disableAutoApprove({
                pin,
                autoApprovalId,
                requestId,
                navigate
              });
            }}
          />
        )}

        {isValidRequest && abdmRequestType === "subscription" && (
          <SubscriptionRequest
            patients={props.patients}
            goBack={props.goBack}
            abdmRequestId={abdmRequestId}
            abdmRequestType={abdmRequestType}
            moreProviderOnclick={setMoreProvider}
            moreProvider={moreProvider}
            acceptRequest={(requestData, autoApprove, pin) => {
              acceptPatientsRequest({
                edit: false,
                requestData,
                autoApprove,
                requestId: abdmRequestId,
                requestType: abdmRequestType,
                navigate
              });
            }}
            editRequest={(requestData, pin) => {
              acceptPatientsRequest({
                edit: true,
                requestType: abdmRequestType,
                requestId: abdmRequestId,
                requestData,
                navigate
              });
            }}
            denyRequest={(denyReason) => {
              denyPatientsRequest({
                requestType: abdmRequestType,
                requestId: abdmRequestId,
                denyReason,
                navigate
              });
            }}
            enableAutoApprove={(data) => {
              enableAutoApprove({
                ...data,
                navigate
              });
            }}
            disableAutoApprove={(data) => {
              disableAutoApprove({
                ...data,
                navigate
              });
            }}
          />
        )}
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(ViewRequest);
